import { CSS, StyleProps } from "@shared/primitive-components"
import { getBackgroundColor, getSeverityLabelPadding, getTextColor } from "./severity"

export const label = (score: number | null) => (props: StyleProps) => ({
  color: getTextColor(score, props),
  backgroundColor: getBackgroundColor(score, props),
  padding: getSeverityLabelPadding(score, props),
})

export const text = (props: StyleProps): CSS => ({
  ...props.theme.fonts.heading,
  fontSize: props.theme.fontSize.body,
  textAlign: `center`,
})
